import React, { useCallback } from 'react';
import { Box, TableCell } from '@mui/material';
import { ICandidateGroup } from './types';
import PoolList from '../CandidateSourcing/PoolList';
import SourceIconLink from '../Components/CustomUIElements/SourceIconLink';

export default function CandidateGroupTableRows({
  column,
  item,
  onViewPool,
  expandedPools,
  onTogglePoolsExpansion
}: {
  column: any;
  item: ICandidateGroup;
  onViewPool?: (poolId: number) => void;
  expandedPools?: Set<number>;
  onTogglePoolsExpansion?: (candidateGroupId: number) => void;
}) {
  const showAllPools = expandedPools?.has(item.id) || false;

  const Link = useCallback(
    ({ content }: { content: string }) => (
      <a
        href={`/admin/candidate_sourcing/candidate_groups/${item.id}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {content}
      </a>
    ),
    [item.id]
  );

  switch (column.id) {
    case 'id':
      return (
        <TableCell
          key={item.id + column.id}
          sx={{
            left: 0,
            width: '100px',
            minWidth: '120px'
          }}
        >
          <Link content={item.id.toString()} />
        </TableCell>
      );
    case 'name':
      return (
        <TableCell>
          <Link content={item.name} />
        </TableCell>
      );
    case 'position':
      return (
        <TableCell>
          <Link content={item.position} />
        </TableCell>
      );
    case 'location':
      return (
        <TableCell>
          <Link content={item.location} />
        </TableCell>
      );
    case 'sources':
      return (
        <TableCell>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
            {item.candidates.map((candidate) => (
              <SourceIconLink key={candidate.url} source={candidate.source} url={candidate.url} />
            ))}
          </Box>
        </TableCell>
      );
    case 'pools':
      return (
        <TableCell sx={{ maxWidth: '20vw' }}>
          <PoolList
            candidateGroup={item}
            onViewPool={onViewPool}
            showAllPools={showAllPools}
            onTogglePoolsExpansion={onTogglePoolsExpansion}
            showItemsThreshold={5}
          />
        </TableCell>
      );
    default:
      return <TableCell></TableCell>;
  }
}

export const candidateGroupTableColumn = [
  { id: 'id', label: 'ID', enabled: true, sortable: true, canToggle: false },
  { id: 'name', label: 'Name', enabled: true, sortable: true, canToggle: false },
  { id: 'position', label: 'Position', enabled: true, sortable: false, canToggle: false },
  { id: 'location', label: 'Location', enabled: true, sortable: false, canToggle: false },
  { id: 'sources', label: 'Sources', enabled: true, sortable: false, canToggle: false },
  { id: 'pools', label: 'Talent Pools', enabled: true, sortable: false, canToggle: false }
];
